import React from 'react'
import type { RowProps } from '@ztechapps/webui.data-tools'
import { Row } from '@ztechapps/webui.data-tools'
import { CheckboxInput } from '@ztechapps/webui.input'
import type { EntityWithSelection } from '@ztechapps/common.hook'
import type { Task } from '@ztechapps/common.contract'
import { useTasksPerProjectContext } from './Context'

export const ListRow = (props: RowProps<EntityWithSelection<Task>>) => {
  const { _selected, name, _id } = props
  const { listWithSelection } = useTasksPerProjectContext()

  return (
    <Row {...props}>
      <td>
        <CheckboxInput
          label={name}
          checked={_selected}
          onChange={() => listWithSelection.toggleSelectBy((e) => e._id === _id)}
        />
      </td>
    </Row>
  )
}
